import { render, staticRenderFns } from "./MatchCard.vue?vue&type=template&id=87fefc7c&scoped=true&"
import script from "./MatchCard.vue?vue&type=script&lang=js&"
export * from "./MatchCard.vue?vue&type=script&lang=js&"
import style0 from "./MatchCard.vue?vue&type=style&index=0&id=87fefc7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fefc7c",
  null
  
)

export default component.exports